import React from 'react';
import './registerrenaming.css';
import CodeEditor from '../codeeditor';
import DepedencyGraph from '../depgraph';
import { Icon, Button } from '@blueprintjs/core';
import codeManager from '../codemanager';
import SolutionPanel from '../solutionpanel';
import SolutionVisualizer from './solutionvisualizer';
import _ from 'lodash';

export default class RegisterRenaming extends React.Component {

    constructor(props) {
        super(props);
        this.state = {  
                        code: "",
                        origInstrList: [],
                        renamedInstrList: [],
                        rat: []
                    };
        this.handleNewCode = this.handleNewCode.bind(this);
    }

    componentDidMount() {
        this.handleNewCode();
    }

    generateIntialRAT() {
        return [ [].concat(_.shuffle(_.range(48)).slice(0, 8), _.shuffle(_.range(48)).slice(0, 4)) ];
    }

    handleNewCode() {
        const code = codeManager.getRandomCode();
        const parsedCode = codeManager.parseCode(code);        
        this.setState({code: code, origInstrList: parsedCode, ...this.applyRenaming(parsedCode, this.generateIntialRAT())});
    }

    renameRegister(reg, rat) {
        if (reg === null)
            return reg;
        if (reg[0] === "R")
            return "U" + rat[parseInt(reg.substring(1))];
        if (reg[0] === "D")
            return "T" + rat[8 + parseInt(reg.substring(1))];
    }

    allocNewRegister(targetReg, rat) {
        const newRat = _.clone(rat);
        if (targetReg === null)
            return { rnTargetReg: null, newRat: newRat };
        if (targetReg[0] === "R") {
            const nextFree = _.max(rat.slice(0, 8))+1;
            newRat[parseInt(targetReg.substring(1))] = nextFree;
            return { rnTargetReg: "U"+nextFree, newRat: newRat };
        }
        if (targetReg[0] === "D") {
            const nextFree = _.max(rat.slice(8, 12))+1;
            newRat[8 + parseInt(targetReg.substring(1))] = nextFree;
            return { rnTargetReg: "T"+nextFree, newRat: newRat };
        }
    }

    applyRenaming(instrList, initialRAT) {
        if (!initialRAT || initialRAT.length === 0)
            return { renamedInstrList: instrList, rat: initialRAT };

        const renamedInstrList = [];
        const rat = _.clone(initialRAT);
        instrList.filter(instr => instr.error === "").forEach((instr, ix) => {
            const rnInstr = _.cloneDeep(instr);
            rnInstr.regA = this.renameRegister(rnInstr.regA, rat[ix]);
            rnInstr.regB = this.renameRegister(rnInstr.regB, rat[ix]);
            const { rnTargetReg, newRat } = this.allocNewRegister(instr.targetReg, rat[ix]);
            rnInstr.targetReg = rnTargetReg;
            rat.push(newRat);
            renamedInstrList.push(rnInstr);
        });

        return { renamedInstrList, rat };
    }

    renderRATSlice(start, end, step) {
        if (this.state.rat.length <= step)
            return <></>;
        else
            return <div className="demo-table-container"><table>
                <thead><tr><th>Logikai</th><th>Fizikai</th></tr></thead><tbody>
                {this.state.rat[step].slice(start, end).map((val, ix) => {
                    if (start + ix < 8)
                        return <tr key={ix}><td>{`R${start+ix}`}</td><td>{`U${this.state.rat[step][start+ix]}`}</td></tr>
                    else
                        return <tr key={ix}><td>{`D${start+ix-8}`}</td><td>{`T${this.state.rat[step][start+ix]}`}</td></tr>
                })}
            </tbody></table></div>;
    }

    render() {

        let error = <></>;
        if (this.state.origInstrList && this.state.origInstrList.some(x => x.error.length > 0)) {
            error = <div className="code-error-area">
                {this.state.origInstrList.filter(x => x.error.length > 0).map((instr, ix) =>
                    <div key={ix}><Icon icon="error"/>&nbsp;{`line ${instr.line}: ${instr.error}`}</div>)}
            </div>
        }

        return (
            <>
                <div className="title-area">
                    <h1>Regiszterátnevezés</h1>
                    <h2>Az álfüggőségek eliminálása fizikai regiszterek bevezetésével</h2>
                </div>
                <div className="demo-emph-row">
                    <div className="registerrenaming-top-row-left-col">
                        <h3>Utasítássorozat:</h3>
                        <CodeEditor 
                            code={this.state.code} 
                            onChange={instrList => this.setState({origInstrList: instrList, ...this.applyRenaming(instrList, [ this.state.rat[0] ]) })} 
                        />
                        <Button 
                            icon="refresh"
                            text="Másik generálása"
                            className="registerrenaming-generate-button"
                            onClick={this.handleNewCode} 
                        />
                    </div>
                    <div className="registerrenaming-top-row-right-col">
                        <h3>A regiszterleképző tábla kezdetben:</h3>
                        <div className="registerrenaming-origrat-area">
                            {this.renderRATSlice(0, 8, 0)}
                            {this.renderRATSlice(8, 12, 0)}
                        </div>                    
                    </div>
                </div>
                {error}
                <div>
                    <h3>1. Feladat</h3>
                    <p>Rajzolja fel az utasítások percedenciagráfját! Az éleket cimkézze fel az egymásrahatások típusának 
                        megfelelően (RAW/WAR/WAW)! Ha két utasítás között több egymásrahatás is van, tüntesse fel mindet!</p>
                </div>
                <div>
                    <SolutionPanel title="Megoldás mutatása">
                        <div className="demo-emph-row">
                            <DepedencyGraph instrList={this.state.origInstrList} />
                        </div>
                    </SolutionPanel>
                </div>
                <div>
                    <h3>2. Feladat</h3>
                    <p> Szüntesse meg a WAW és WAR adat-egymásrahatásokat regiszter átnevezés segítségével! 
                        A regiszter átnevezést végezze el minden utasításra szisztematikusan! A lebegőpontos 
                        fizikai regisztereket jelölje T0, T1, T2, ..., az egész típusú fizikai regisztereket
                        U0, U1, U2, .... A regiszterleképző tábla tartalma a fentiek szerint adott.
                        Ha új fizikai regiszterre van szükség, válassza a legnagyobb sorszámú foglalt fizikai regiszter
                        után következőt!
                    </p>
                </div>
                <div>
                    <SolutionPanel title="Megoldás mutatása">
                        <div className="demo-emph-row">
                            <SolutionVisualizer 
                                origInstrList={this.state.origInstrList.filter(instr => instr.error === "")}
                                renamedInstrList={this.state.renamedInstrList}
                                rat={this.state.rat}
                            />
                        </div>
                    </SolutionPanel>
                </div>                
                <div>
                    <h3>3. Feladat</h3>
                    <p>Rajzolja fel a regiszterátnevezés eredményeként kapott utasítások percedenciagráfját! Az éleket cimkézze fel az egymásrahatások típusának 
                        megfelelően (RAW/WAR/WAW)! Ha két utasítás között több egymásrahatás is van, tüntesse fel mindet!</p>
                </div>
                <div>
                    <SolutionPanel title="Megoldás mutatása">
                        <div className="demo-emph-row">
                            <DepedencyGraph instrList={this.state.renamedInstrList} />
                        </div>
                    </SolutionPanel>
                </div>
            </>
        );
    }
}